export const startTime = new Date();

export const getTabLifetime = () => {
  const currentTime = new Date();
  const elapsedMilliseconds = currentTime.getTime() - startTime.getTime();
  const elapsedSeconds = elapsedMilliseconds / 1000;
  return elapsedSeconds;
};
